import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { CloseIcon } from '../icon'
import { RiArrowDropDownLine, RiArrowDropUpLine } from 'react-icons/ri'
import PopUpHamburgMenu from './PopUpHamburgMenu'
import toast from 'react-hot-toast'
import { GlobalContext } from '../../appContext/GlobalContext'
// import { IoCheckmark } from 'react-icons/io5'

const HamburgerInside = ({ setShowMenu, active, locationId, tableId, address, colorCode }) => {
  const { t, i18n } = useTranslation()
  const [selectedLanguage, setSelectedLanguange] = useState()
  const [showLang, setShowLang] = useState(false)
  const [showPopUp, setShowPopUp] = useState(false)
  const [showAskBill, setShowAskBill] = useState(false)
  const [showCallWaiter, setShowCallWaiter] = useState(false)
  const [langOpen, setLangOpen] = useState(false)
  const [loadingClearTable, setLoadingClearTable] = useState(false)
  const { setIsEN, isEN, location } = useContext(GlobalContext)
  const languages = [
    { code: 'RO', flag: '/assets/images/ro.png', i18nCode: 'ro',label: 'Română' },
    { code: 'EN', flag: '/assets/images/en.png', i18nCode: 'en', label: 'English' },
    // { code: 'HUN', flag: '/assets/images/hungary.png' },
  ]
  const [os, setOS] = useState('');


  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      setOS('iOS');
    } else if (/Android/.test(userAgent)) {
      setOS('Android');
    } else {
      setOS('Other');
    }

    if(isEN) {
        setSelectedLanguange('EN')
        i18n.changeLanguage('en')
    } else {
        setSelectedLanguange('RO')
        i18n.changeLanguage('ro')
    }
  }, []);

  const handleLinkClick = () => {
    setShowMenu(false)
  }

  const changeLanguage = (language, code) => {
    i18n.changeLanguage(code.toLowerCase())
    setSelectedLanguange(language)
    setShowLang(false)
    setLangOpen(false)
  }

  const handleOpenMap = () => {

    // let testAddress = 'str Izlazului 10, Cluj-Napoca, Cluj, 400609'
    const appleMapsUrl = `maps://search?q=${encodeURIComponent(address)}`;
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    if(location?.pin_url){
        window.open(location?.pin_url, '_blank')
    } else {
        if(os.toLocaleLowerCase() == 'ios'){
            // here should be logic for ios user to choose which maps they want to use
            window.open(appleMapsUrl, '_blank')
        } else {
            window.open(googleMapsUrl, '_blank')
        }
    }
  };

  const add3Hours = () => {
    const currentDate = new Date();
    currentDate.setHours(currentDate.getHours() + 10); 
    return currentDate.toISOString(); 
  }

  const handleClearTable = async (metaDt, withUrl = false) => {
    setLoadingClearTable(true)
    const currentDatePlus3Hours = add3Hours()

    const formattedDate = currentDatePlus3Hours.slice(0, 19)
    let bodyData = {
        locationId:locationId,
        tableId:tableId,
        metadata:metaDt,
        url:( withUrl? location?.segway ?? '' : ''),
        expirationDate:formattedDate
    }
    try {
        await fetch(`/api/partners/ebriza_pushtablemetadata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(bodyData),
        })
        toast.success(t('header.successMessage'))
        
    } catch (error) {
        toast.error(t('errorMessage'), {
            position: 'bottom-right',
          })
    } finally{
        setShowPopUp(false)
        setLoadingClearTable(false)
    }
  }


  return (
    <div
      className={`fixed z-40 top-0 right-0 w-full h-full bg-[#00000091] transition-all ${
        active
          ? 'opacity-100 pointer-events-auto'
          : 'opacity-0 pointer-events-none'
      }`}
    >
      <div
        className="absolute w-full top-0 left-0 bg-white shadow-lg border flex flex-col h-full transform translate-x-0 ease-in-out duration-500 overflow-auto pb-[30px]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-full flex justify-end items-center mt-4 px-8">
            <div onClick={handleLinkClick}>
                <CloseIcon />
            </div>
        </div>
        {address && (
            <div
            className="mt-6 flex items-center justify-between text-left pl-5 pr-9 duration-300 w-full"
            style={{ borderColor: '#FFB800' }}
            onClick={handleOpenMap}
            >
                <div className='flex'>
                    <img
                    alt="Location"
                    src="/assets/images/icons/location.svg"
                    width={24}
                    />
                    <span className='text-base ml-2 text-clip' >
                        {address}
                    </span>
                </div>
                <RiArrowDropDownLine color={ '#3C3A34'} size={35} className='min-w-[35px]' />
            </div>
        )}
        <div className='mt-8 pl-5 pr-9'>
            {location?.call_waiter && (
              <div 
                  onClick={() => setShowCallWaiter(true)}
                  className='flex py-3 border-b-2'
              >
                  <img
                  alt="call-waiter"
                  src="/assets/images/icons/call_waiter.png"
                  width={22}
                  className='h-[22px]'
                  />
                  <span className='text-base ml-2' >
                      {t('header.call_waiter')}
                  </span>
              </div>
            )}
            {location?.ask_bill && (
              <div 
                  onClick={() => setShowAskBill(true)}
                  className='flex py-3 border-b-2'
                >
                  <img
                  alt="ask-bill"
                  src="/assets/images/icons/ask_bill.png"
                  width={22}
                  />
                  <span className='text-base ml-2' >
                      {t('header.ask_bill')}
                  </span>
              </div>
            )}
            {location?.clear_table && (
              <div 
                  onClick={() => setShowPopUp(true)}
                  className='flex py-3 border-b-2'
              >
                  <img
                  alt="clear-table"
                  src="/assets/images/icons/new-broom.png"
                  width={22}
                  />
                  <span className='text-base ml-2' >
                      {t('header.clearTable')}
                  </span>
              </div>
            )}
            <div
                className="mt-10 flex items-center justify-between text-left duration-300 "
                style={{ borderColor: '#FFB800' }}
                onClick={() => {
                    setShowLang(prev => !prev)
                    setLangOpen(prev => !prev)
                }}
            >
                <div className='flex'>
                    <img
                    alt="globe"
                    src="/assets/images/icons/globe.svg"
                    width={22}
                    />
                    <span className='text-base ml-2' >
                        {`${t('header.language')}: ${languages.find((lang) => lang.code === selectedLanguage)?.code}`}
                    </span>
                </div>
                {langOpen ? <RiArrowDropUpLine color={ '#3C3A34'} size={35} /> : <RiArrowDropDownLine color={ '#3C3A34'} size={35} />}
            </div>
            {showLang && (
                <div className="absolute z-0 mt-2 w-[calc(100%_-_56px)] shadow-lg bg-white rounded-md">
                  {languages.map((lang) => (
                    <div
                      key={lang.code}
                      className={`cursor-pointer p-2 px-3 flex justify-between text-black text-[10px] items-center ${
                        selectedLanguage === lang.code ? 'bg-primary bg-opacity-10' : ''
                      }`}
                      onClick={() => {
                        if(lang.code == 'EN'){
                            setIsEN(true)
                        } else {
                            setIsEN(false)
                        }
                        changeLanguage(lang.code, lang.i18nCode)
                        }
                      }
                    >
                        <div>
                            <img
                                src={lang.flag}
                                alt={lang.code}
                                className="inline-block w-6 h-4 mr-2"
                            />
                            {lang.label}
                        </div>
                      {selectedLanguage == lang.code && (
                        // <span className="text-sm font-bold" style={{ color: colorCode }}>
                        //     <IoCheckmark />
                        // </span>
                        <div>
                            <span style={{color: colorCode}} className={`text-lg material-symbols-outlined`}>
                                check
                            </span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
              
        </div>
        <div className='pl-5 pr-9 flex flex-col-reverse  h-full'>
          <div className='flex space-x-5 justify-center items-center'>
            {location?.instagram && <a rel='noopener' href={`https://${location?.instagram}`} target='_blank'><img src='/assets/images/icons/ig.png' alt='IG' width={24} /></a>}
            {location?.linkedin && <a rel='noopener' href={`https://${location?.linkedin}`} target='_blank'><img src='/assets/images/icons/linkedin.png' alt='linkedin' width={24} /></a>}
            {location?.facebook && <a rel='noopener' href={`https://${location?.facebook}`} target='_blank'><img src='/assets/images/icons/facebook.png' alt='FB' width={24} /></a>}
            {location?.tiktok && <a rel='noopener' href={`https://${location?.tiktok}`} target='_blank'><img src='/assets/images/icons/tiktok.png' alt='tiktok' width={24} /></a>}
            {location?.youtube && <a rel='noopener' href={`https://${location?.youtube}`} target='_blank'><img src='/assets/images/icons/youtube.png' alt='youtube' width={24} /></a>}
            {location?.twitter && <a rel='noopener' href={`https://${location?.twitter}`} target='_blank'><img src='/assets/images/icons/twitter.png' alt='twitter' width={24} /></a>}
            {location?.website && <a rel='noopener' href={`https://${location?.website}`} target='_blank'><img src='/assets/images/icons/website.png' alt='website' width={24} /></a>}

          </div>
          {(location?.google_review_url || location?.google_review_link || location?.review_url || location?.review_link) && (
            <div className='mb-14 space-y-2'>
              {(location?.google_review_url || location?.google_review_link ) && <a href={`https://${(location?.google_review_url || location?.google_review_link)}`} rel='noopener' target='_blank'><div className='flex items-center justify-center border-2 rounded-full py-3'>{t('header.leave_feedback')}<img src='/assets/images/icons/google-maps.png' className='h-[18px] ml-1' alt='gmaps' width={13} /></div></a>}
              {(location?.review_url || location?.review_link )&& <div className='border-2 rounded-full py-3'><a className='flex items-center justify-center' rel='noopener' href={`https://${(location?.review_url || location?.review_link)}`} target='_blank'>{t('header.give_feedback')}<img src='/assets/images/icons/chat.png' className='ml-1' alt='gmaps' width={20} /></a></div>}
          </div>
          )}
        </div>
      </div>
        {showPopUp && (
            <PopUpHamburgMenu 
                desc={t('header.askToClearTable')}
                icon={'/assets/images/icons/new-broom.png'}
                handleClosePopUp={setShowPopUp}
                onConfirmClearTable={() => handleClearTable('DEBARASARE', true)}
                loading={loadingClearTable}
                colorCode={colorCode}
            />
        )}
        {showAskBill && (
            <PopUpHamburgMenu 
                desc={t('header.ask_bill')}
                icon={'/assets/images/icons/ask_bill.png'}
                handleClosePopUp={setShowAskBill}
                onConfirmClearTable={() => handleClearTable("NOTA")}
                loading={loadingClearTable}
                colorCode={colorCode}
            />
        )}
        {showCallWaiter && (
            <PopUpHamburgMenu 
                desc={t('header.call_waiter')}
                icon={'/assets/images/icons/call_waiter.png'}
                handleClosePopUp={setShowCallWaiter}
                onConfirmClearTable={() => handleClearTable("HELP")}
                loading={loadingClearTable}
                colorCode={colorCode}
            />
        )}
    </div>
  )
}

export default HamburgerInside
